import React from 'react'
import SingleProvider from '../../home/listings/service provider/SingleProvider'
import Home from '../../home/Home'

const SingleServiceView = () => {
  return (
        <>
        <Home />
        <SingleProvider />
        </>
  )
}

export default SingleServiceView
